import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DepartmentsService } from 'src/app/admin/data/services/departments.service';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss']
})
export class ImageViewComponent implements OnInit {
  imageUrl: string;
  currentUser: any;
  userFullName: any;
  userImg: string;   
  userId: number; 
   userImg1: string;
  loading = false;
  profileForm: FormGroup;
  urlAddProfile!: string;
  urlUpdateProfile!: string;
  urlGetProfile!: string;

  selectedImage!: File;
  imageUrl1: SafeResourceUrl;
  constructor(
    public dialogRef: MatDialogRef<ImageViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tokenStorageService: TokenStorageService,
    public fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private deptService: DepartmentsService
  ) {
    this.imageUrl = data.currentUser.imageBanner; 
  }

  ngOnInit(): void {
    this.currentUser = this.tokenStorageService.getUser();
    this.userFullName = this.currentUser.userName;
    this.userId = this.currentUser.id;
    this.userImg =`data:image/jpeg;base64,${this.currentUser.imageBanner}`;;
    const blob = this.dataURItoBlob(this.userImg);
    const blobUrl = URL.createObjectURL(blob);
    this.imageUrl1 = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    this.loading = true;
   
  }

  deleteImage(): void {
    this.loading = true;
    setTimeout(() => {
    
      this.deptService.deleteProfile(this.data.currentUser.id).subscribe(
        () => {
          this.imageUrl = null;
          this.loading = false;
        
          Swal.fire({
            icon: 'success',
            title: 'user Photo',
            text: 'Deleted sucessful',
            confirmButtonText: 'OK'
          });
          this.dialogRef.close();
        },
        error => {
          console.error('Error deleting image:', error);
          this.loading = false;
             
          Swal.fire({
            icon: 'error',
            title: 'user Photo',
            text: 'Failed to delete',
            confirmButtonText: 'OK'
          });
        }
      );
    }, 2000);
  }
  onCancel() {
  
    this.dialogRef.close();
  }
  handleFileInput(event: any): void {
    if (event.target.files && event.target.files.length) {
      this.selectedImage = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedImage);
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result; 
      };
    }
  
    this.loading = true;
    setTimeout(() => {
      const uploadData = {
        userName: this.currentUser.userName,
        imageBanner: this.imageUrl.split(',')[1] 
      };
  
      this.deptService.uploadImage(uploadData).subscribe(
        () => {
          this.loading = false;
          this.showSuccessAlert('Uploaded Successfully');
        },
        error => {
      
          this.loading = false;
          this.showErrorAlert(error);
        }
      );
    }, 3000);
  }
  
  private showSuccessAlert(message: string): void {
    Swal.fire({
      icon: 'success',
      title: 'User Profile Photo',
      text: message,
      confirmButtonText: 'OK'
    });
    this.dialogRef.close();
  }
  
  private showErrorAlert(message: string): void {
    Swal.fire({
      icon: 'error',
      title: 'User Profile Photo',
      text: message,
      confirmButtonText: 'OK'
    });
  }
  
  private dataURItoBlob(dataURI: string): Blob {
    const isBase64 = /^data:image\/([a-zA-Z]*);base64,/.test(dataURI);
      
    if (!isBase64) {
      throw new Error('Invalid dataURI format');
    }
    
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    
    return new Blob([ab], { type: mimeString });
  }
}
